// extracted by mini-css-extract-plugin
module.exports = {"pageSecondaryMenuWrapper":"styles_pageSecondaryMenuWrapper__g_VCG"};